var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWindDirectionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ka1r5ojaha",
    width: "374.3%",
    height: "374.3%",
    x: "-137.1%",
    y: "-137.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    operator: "dilate",
    radius: 3,
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 13
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "6b6xvt16xb",
    cx: 17.5,
    cy: 17.5,
    r: 17.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1332 -267) translate(1190 48) translate(142 219)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#ka1r5ojaha)",
    xlinkHref: "#6b6xvt16xb"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#6b6xvt16xb"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H19.886V19.886H0z",
    transform: "translate(-1332 -267) translate(1190 48) translate(142 219) translate(7.955 8.75)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#1E2447"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.397 0L0 1.659l4.397 1.659-.393-1.187h9.671l.81 1.048h4.804l-1.177-1.522.675-.872.502-.65h-4.804l-.81 1.048h-9.67L4.397 0zM14.73.896h.492l-.588.761.588.76h-.492l-.589-.76.589-.76zm1.324 0h.492l-.588.761.588.76h-.492l-.589-.76.589-.76zm1.324 0h.492l-.588.761.588.76h-.492l-.589-.76.589-.76z",
    transform: "translate(-1332 -267) translate(1190 48) translate(142 219) translate(7.955 8.75) translate(0 7.292)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M8.993 0.531H9.993V5.851999999999999H8.993z",
    transform: "translate(-1332 -267) translate(1190 48) translate(142 219) translate(7.955 8.75) translate(0 7.292)"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindDirectionIcon);
export default __webpack_public_path__ + "static/media/wind-direction-icon.eb109679.svg";
export { ForwardRef as ReactComponent };